module.exports = __webpack_public_path__ + "static/media/errorTll.a7ef32d6.svg";